<template>
  <div class="popup-IPN popup-all">
    <div class="popup-container">
      <div class="popup-vue has-header">
        <div class="popup-header">
          <img class="popup-logo" src="/img/credit-landing-vue/popup-logo.svg">
          <div class="popup-tel" v-html="__t('Телефон попапа инн')"></div>
        </div>
        <img class="popup-close" src="/img/credit-landing-vue/popup-close.svg" alt="Close" @click="popupClose()">
        <div class="popup-title" v-html="__t('Перевірте дані')"></div>
        <div class="popup-description" v-html="__t('Ваш ІПН не збігається із наданими персональними даними. Можливо ви неправильно ввели дату народження')">
        </div>
        <form @submit.prevent id="callback-popup-ipn">
          <div class="popup-inputs">
            <div class="input-field">
              <label for="name">{{__t('ІПН')}}</label>
              <input type="tel" :value="client_ipn" name="ipn"
                     ref="client_ipn"
                     @input="inputChange"
                     v-mask="'##########'">
            </div>
            <div class="input-field">
              <label for="phone">{{__t('Дата народження в попапе ІПН')}}</label>
              <input type="tel" :value="client_birthday" name='client_date_of_birth'
                     ref="minAge"
                     @input="inputChange"
                     v-mask="'##.##.####'">
            </div>
            <input type="hidden" ref="inactive_time" name="time">
            <div class="btn-group fw">
              <button type="button" class="popup-button btn violet-btn" ref="btn_fix" @click="closeAndChangeData"
                      disabled>{{__t('Виправити')}}
              </button>
              <button type="submit" class="popup-button btn green-btn">{{__t('Ні, все правильно')}}</button>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "popup-IPN",
        props: [
            'client_birthday',
            'client_ipn',
            'min_age',
            "max_age",
            'type_activity'
        ],
        data() {
            return {
                new_client_ipn: this.client_birthday,
                new_client_birthday: this.client_ipn
            }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            doAllRight() {

                this.$el.style.display = 'none';
                this.$emit("doAllRight");
            },
            closeAndChangeData() {
                this.changeData();
                this.popupClose();
            },
            popupClose: function () {
                this.$el.style.display = 'none';
            },
            changeData() {


                var arrD = this.$refs.minAge.value.split(".");
                arrD[1] -= 1;
                var d = new Date(arrD[2], arrD[1], arrD[0]);
                let maxDate = new Date();
                let minDate = new Date();
                let maxAge = this.max_age;
                let minAge = this.min_age;
                maxDate.setFullYear(maxDate.getFullYear() - maxAge);
                minDate.setFullYear(minDate.getFullYear() - minAge);
                console.log(d + " <= " + maxDate + " >= " + minDate);
                if (d <= maxDate || d >= minDate) {
                    axios.post('/cash/age-refusing');
                    this.$emit('error');
                } else {
                    let axiosConfig = {
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    };

                    let axiosData = JSON.stringify({
                        client_date_of_birth: this.$refs.minAge.value,
                        client_inn: this.$refs.client_ipn.value
                    });
                    this.$emit("update", {
                        client_date_of_birth: this.$refs.minAge.value,
                        client_inn: this.$refs.client_ipn.value
                    });

                    axios.post('/cash/edit-inn', axiosData, axiosConfig);
                    this.$emit('doRequest');
                }


            },
            isValidDate(day, month, year) {
                const d = new Date(year, month - 1, day);
                return (
                    d.getFullYear() === +year &&
                    d.getMonth() === month - 1 &&
                    d.getDate() === +day
                );
            },
            inputChange() {
                const ipn = this.$refs.client_ipn.value;
                const dob = this.$refs.minAge.value;

                const arrD = dob.split(".");
                if (arrD.length !== 3) {
                    this.$refs.btn_fix.disabled = true;
                    return;
                }

                const [day, month, year] = arrD.map(num => parseInt(num, 10));

                const validDate = this.isValidDate(day, month, year);

                const validIpn = /^\d{10}$/.test(ipn);

                this.$refs.btn_fix.disabled = !(validDate && validIpn);
            },

            popupShow: function () {
                this.$refs.btn_fix.disabled = true;
                this.$el.style.display = 'block';
            },
            goNext() {
                this.$emit('gonext');
                return false;
            },
            parseUaID(ipn) {

                let split = ipn.split('');

                let summ = +split[0] * (-1) + +split[1] * 5 + +split[2] * 7 + +split[3] * 9 + +split[4] * 4 + +split[5] * 6 + +split[6] * 10 + +split[7] * 5 + +split[8] * 7;

                let control = (summ - (11 * Math.floor(summ / 11)));

                if (control == 10) {
                    control = 0;
                }

                let status = (control == +split[9]) ? true : false;
                // true if  inn is existing

                if (status) {

                    let pathOfIPN = +ipn.substr(0, 5);
                    let startDate = '01.01.1900';

                    var new_date = moment(startDate, "DD-MM-YYYY").add(--pathOfIPN, "days");

                    let birthday = {
                        day: new_date.format('DD'),
                        month: new_date.format('MM'),
                        year: new_date.format('YYYY')
                    };

                    return birthday;

                } else {
                    return false;
                }

            },
            validation: function () {
                let self = this;

                $.validator.addMethod("minAge", function (value, element, arg) {
                    var arrD = value.split(".");
                    arrD[1] -= 1;
                    var d = new Date(arrD[2], arrD[1], arrD[0]);
                    let minDate = new Date();
                    let age = self.min_age;
                    minDate.setFullYear(minDate.getFullYear() - age);
                    if (d <= minDate) {
                        return true;
                    } else {
                        return false;
                    }
                }, 'Умова по віку не виконується');

                let form = $('#callback-popup-ipn').validate({
                    rules: {
                        ipn: {
                            required: true,
                        },
                        client_date_of_birth: {
                            required: true,
                            normalDate: true,
                            minAge: true
                        },

                    },
                    messages: {
                        ipn: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                        client_date_of_birth: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            minlength: __t('Введіть дату у форматі ДД.ММ.РРРР'),
                            maxlength: __t('Введіть дату у форматі ДД.ММ.РРРР'),
                            normalDate: __t("Виправте дату"),
                        },

                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element);
                        element.css('border-color', 'red');
                        if ($(element).hasClass('limit')) {
                            let afterElement = $(element).closest('.range-input-field');
                            error.insertAfter(afterElement);
                        }
                        if ($(element).hasClass('birthday')) {
                            let afterElement = $(element).closest('.input-flex-container');
                            error.insertAfter(afterElement);
                        }
                        if ($(element).hasClass('activities')) {
                            let afterElement = $(element).closest('.select-wrapper');
                            error.insertAfter(afterElement);
                        }
                    },
                    submitHandler: function (form) {

                      jQuery.ajax({
                        headers: {
                          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        type: "POST",
                        url: '/cash/all-right',
                        cache: false,
                        dataType: "json",
                        success: function (response) {
                          self.$emit('changeIPNandDate', {
                            new_client_ipn: self.$refs.client_ipn.value,
                            new_client_birthday: self.$refs.minAge.value
                          });

                          self.popupClose();
                          self.$emit('doRequest');
                          console.log("gonext emit");
                        },
                        error: function (error) {
                        }
                      });

                    }
                });

            },
            updateIpn() {
                this
            }
        },
        mounted() {
            this.validation();
        }
    }
</script>
